// Copyright 2019-2020 @Premiurly/polkassembly authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.

export const REACT_APP_SUBSCAN_API_KEY = '74d1845ab15f4b889a64dfef074ef222';
export const FIREBASE_API_KEY = process.env.FIREBASE_API_KEY;
